// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DynProperty } from "../../../Commons/DynProperty.js";
import { ErrorInformationStorage } from "../../../Commons/ErrorInformationStorage.js";
import { Resources } from "../../../Commons/properties/Resources.js";
import { BaseItem } from "../BaseItem.js";
import { ColumnParams } from "../ColumnParams.js";


export let NewVerticalPanelTableItem = function (/*string*/ id, /*string*/ rowKey, /*string*/ RowValue, /*string*/ GroupStr, /*int*/ SortIndex, /*SessionSettings*/ sessionSettings)
{
    BaseItem.call(this, sessionSettings);

    this.itemId = id;
    this.RowKey = rowKey;
    this.RowKey_Localized = rowKey;
    this.RowValue = RowValue;
    this.GroupStr = GroupStr;
    this.SortIndex = SortIndex;
    this.DynPropertyControltype = DynProperty.STRING;
    this.GroupIndex = null;
};
NewVerticalPanelTableItem.prototype = Object.create(BaseItem.prototype);


NewVerticalPanelTableItem.prototype.ColumnCount = function ()
{
    return NewVerticalPanelTableItem.columnsParams.length;
}

NewVerticalPanelTableItem.prototype.getColumnData = function (column)
{
    var o = this.getColumnValue(column);;
    return { Value: o, FormattedValue: (o ? o.toString() : "") };
}

NewVerticalPanelTableItem.prototype.getColumnValue = function (column)
{
    try
    {
        switch (column)
        {
            case 0:
                return this.RowKey_Localized;

            case 1:
                return this.RowValue;

            case 2:
                return this.GroupStr; //GroupStr;

            case 3:
                return this.SortIndex;

            default:
                return "";
        }
    }
    catch (ex)
    {
        ErrorInformationStorage.GetException(ex);
        console.log(ex);
        return "";
    }
}

NewVerticalPanelTableItem.prototype.GetColumnParams = function (column)
{
    var result = NewVerticalPanelTableItem.columnsParams[column];
    var isHidden = Resources.isHidden(result.HeaderKey) || (column === 2 || column === 3);
    result.Hidden = isHidden;
    return result;
}


/// <summary>
/// Здесь хранятся настройки колонок (один экземпляр на класс)
/// </summary>
NewVerticalPanelTableItem.columnsParams =
[
    new ColumnParams("AccountDetailesPanel.quickTable.Name", 200, 0, false, true, false),
    new ColumnParams("AccountDetailesPanel.quickTable.Value", 300, 0, false, true, false),
    new ColumnParams("Group", 80, 0, false, false, true),
    new ColumnParams("SortIndex", 80, 0, false, false, true)
];

